//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "@lottiefiles/lottie-player";
export default {
  props: {
    dance: {
      default: "Waltz",
    },
    figure: {
      default: "RF Closed Change",
    },
    level: {
      default: "Newcomer",
    },
    figureData: {
      default: null,
    },
    animationData: {
      default: null,
    },
  },
  data() {
    return {
      dances: ["Waltz", "Tango", "Viennese Waltz", "Slow Foxtrot", "Quickstep"],
      levels: ["Newcomer", "Bronze", "Silver", "Gold"],
      step: "0",
      role: "Both",
      camera: {
        x: 0,
        y: 0,
        zoom: 1,
        rotation: 0,
        fullscreen: false,
      },
    };
  },
  computed: {
    hasVisData() {
      return this.animationData
        ? true
        : this.figureData
        ? "stepsMan" in this.figureData
          ? true
          : false
        : false;
    },
  },
  watch: {
    figureData(newFigure) {
      if (newFigure) {
        this.setCamera();
      }
      this.step = 0;
    },
    animationData() {
      if (this.$refs.player && this.animationData) {
        this.$refs.player.load(this.animationData);
      }
    },
  },
  methods: {
    getURLByLevelFigure(level, figure) {
      return `/${this.dance}/${level}/${figure}`.replace(/\s/g, "-");
    },
    setCamera() {
      if (this.figureData.cameraOffset) {
        this.camera.x = this.figureData.cameraOffset[0]
          ? this.figureData.cameraOffset[0]
          : 0;
        this.camera.y = this.figureData.cameraOffset[1]
          ? this.figureData.cameraOffset[1]
          : 0;
      }
    },
    setRole(val) {
      this.role = val;
    },
    setStep(val) {
      this.step = val;
    },
    setRotation(val) {
      this.camera.rotation = val;
    },
    setZoom(val) {
      this.camera.zoom = val;
    },
    setFullscreen(val) {
      this.camera.fullscreen = val;
    },
    waitForData() {
      return new Promise((resolve) => {
        var timer = setInterval(() => {
          if (this.figureData && this.animationData) {
            resolve();
            clearInterval(timer);
          }
        }, 1000);
      });
    },
  },
  async mounted() {
    await this.waitForData();
    this.$refs.player.load(this.animationData);
  },
};
